import { FileSyncOutlined, PrinterOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, Space, Typography } from 'antd';
import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { FormStempContentProps } from '../../constants/constants';
import { getFileName } from '../../functions/functions';
import { DocumentPreview } from './previewPDFComponents/DocumentPreview';

export const PreviewDocument = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    const componentRef = useRef<HTMLDivElement | null>(null);
    const studentName = form.getFieldValue(['registration', 'student']);
    const birthYear = form.getFieldValue(['registration', 'birthYear']);

    return (
      <div
        style={{
          paddingLeft: 48,
          display: currentStep === 12 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 24, fontWeight: 'normal' }}
          level={4}
        >
          Duomenų peržiūra
        </Typography.Title>
        <ConfigProvider
          theme={{
            token: {
              fontSizeHeading1: 28,
              fontSizeHeading2: 21,
              fontSize: 12,
              lineHeight: 1.2,
            },
          }}
        >
          <DocumentPreview form={form} ref={componentRef} />
        </ConfigProvider>
        <Space>
          <Button onClick={form.submit}>
            <FileSyncOutlined />
            Išsaugoti formą
          </Button>
          <ReactToPrint
            trigger={() => (
              <Button>
                <PrinterOutlined />
                Atspausdinti
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle="@page {margin: 5mm 5mm 15mm 5mm;}"
            documentTitle={getFileName({
              student: studentName,
              birthYear: birthYear,
              extension: 'pdf',
            })}
          />
        </Space>
      </div>
    );
  },
);
